import { api } from '@/core/helpers/axiosHelper';
import { extractFilename } from '@/modules/board/composables/useBlobDownload';

export default {
   async postPoolStructure(body: FormData) {
      return await api
         .post('/import/pool-structure', body, {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         })
         .then((response) => response.data)
         .catch((error) => {
            return Promise.reject(error.response.data.errors);
         });
   },
   async getCandidatesExample() {
      return await api.get('/import/candidates/example').then((response) => response.data);
   },
   async getPlanningExample() {
      return await api.get('/import/planning/example').then((response) => ({
         data: response.data,
         fileName: extractFilename(response.headers?.['content-disposition']),
      }));
   },
   async postCandidates(body: FormData) {
      return await api
         .post('/import/candidates', body, {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
            params: { include: 'person,tenant' },
         })
         .then((response) => {
            return response.data;
         });
   },
   async postPlanning(body: FormData) {
      return await api
         .post('/import/planning', body, {
            headers: {
               'Content-Type': 'multipart/form-data',
            },
         })
         .then((response) => {
            return response.data;
         })
         .catch((error) => {
            return Promise.reject(error.response.data.errors);
         });
   },
};
